import { recordMark } from '@stitch-fix/client-analytics-reporter';
import BNC from '../../tracking/bncTracker';
import CML from '../../tracking/cmlTracker';
import ShoppingBagTracker from '../../../../AddToBagButton/shoppingBagTracker';
import StyleShuffleShopTracker from '../../tracking/styleShuffleShopTracker';
import SearchResultsTracker from '../../tracking/searchResultsTracker';
import SourceType from '../../helpers/SourceType';
import SubSourceType from '../../helpers/SubSourceType';

export const recordGraphSuccess = operationName => {
  recordMark('pdp_graph_query_completed', {
    operation_name: operationName,
    query_succeeded: true,
  });
};

export const recordGraphError = operationName => {
  recordMark('pdp_graph_query_completed', {
    operation_name: operationName,
    query_succeeded: false,
  });
};

export const getReferringSkuIdInStock = ({
  productSkuId,
  outOfStock,
  referringSkuId,
}) => {
  let referringSkuInStock;

  try {
    if (referringSkuId !== 0) {
      referringSkuInStock = sessionStorage.getItem(`${referringSkuId}-inStock`);
    } else {
      referringSkuInStock = !outOfStock;
      sessionStorage.setItem(`${productSkuId}-inStock`, referringSkuInStock);
    }
  } catch {
    /* If storage isn't supported then skip */
  }

  return referringSkuInStock;
};

export const trackPDPViewEvent = state => {
  const sharedContext = {
    source: state.source,
    skuId: state.productSkuId,
    outOfStock: state.isSkuOutOfStock,
    referringSkuInStock: getReferringSkuIdInStock({
      productSkuId: state.productSkuId,
      outOfStock: state.isSkuOutOfStock,
      referringSkuId: state.referringSkuId,
    }),
    limitedStock: state.isSkuLimitedStock,
    hideItemLinkShown:
      state.canHideItem &&
      String(state.selectedSkuId) === String(state.productSkuId),
    subSource: state.subSource,
  };

  if (state.source === SourceType.SYL) {
    CML.trackPDPViewEvent({
      ...sharedContext,
      outfitId: state.outfitId,
      collection: state.collectionName,
    });
  } else if (
    state.source === SourceType.SHOPPING_BAG &&
    state.subSource === SubSourceType.SIMILAR_ITEMS
  ) {
    // Algos asked for different event attributes when similar items are viewed
    // from the shopping bag. SHOC-502
    ShoppingBagTracker.trackShoppingBagSimilarItemPDPViewEvent(sharedContext);
  } else if (state.source === SourceType.CATEGORIES) {
    StyleShuffleShopTracker.trackPDPViewEvent({
      ...sharedContext,
      collection: state.collectionName,
    });
  } else if (state.source === SourceType.SEARCH_RESULTS) {
    SearchResultsTracker.trackPDPViewEvent({
      ...sharedContext,
      queryId: state.queryId,
    });
  } else {
    BNC.trackPDPViewEvent({
      ...sharedContext,
      keptItemId: state.productSkuId,
    });
  }
};

export const DISCOVERED_PRODUCTS_FILTERS = {
  NONE: 'NONE',
  MATCH_DEPARTMENT: 'MATCH_DEPARTMENT',
};
